export default "__VITE_ASSET__9b22f0f8__"